import { useState } from 'react';
import api from '../api'; // Atualize o caminho para sua instância da API
import secureStorage from '../../utils/SecureStorage';

const useBuscaClolaborador = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiUrl1 = process.env.REACT_APP_API_BASE_17;
  let id = secureStorage.getItem("id_r");

  const loadregistros = async (idrede) => {
    setLoading(true);
    try {
      const response = await api.get(`${apiUrl1}${idrede}`);
      setSearchResults(response.data.cadastros);
      setError(null); // Limpa qualquer erro anterior
    } catch (error) {
      setError("Erro ao buscar cadastros. Veja o console para mais detalhes.");
      setSearchResults([]); // Limpa os resultados anteriores
    } finally {
      setLoading(false);
    }
  };

  return { searchResults, loadregistros, loading, error };
};

export default useBuscaClolaborador;